import script from "./SectionTitleLineWithButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionTitleLineWithButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__